import React from 'react';
import { CustomBottomBar } from '@components';
import { Button, Container, Typography } from '@design-system';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import './WelcomePage.scss';
import logoEcs from '@assets/images/logo/ecs-logo.png';

export const WelcomePage: React.FC = () => {
    const navigate = useNavigate();

    const handleStart = () => {
        navigate('/company-choice');
    };

    return (
        <Container className="welcome-page welcome-page-custom-bottom-bar" height="fill">
            <Container center column padding="large" height="fill" className="welcome-content">
                <img src={logoEcs} alt="Logo de l'application" className="welcome-logo" />
                <Typography intrinsic="h1" className="text-center">
                    Bienvenue sur votre nouvelle application !
                </Typography>
                <Typography intrinsic="p" variant="secondary" color="marine" className="mt-medium-spacing text-center">
                    L'outil au service du progrès et de la qualité.
                </Typography>
            </Container>
            <CustomBottomBar className="welcome-bottom-bar">
                <Button
                    onClick={handleStart}
                    color="marine"
                    size="fullwidth"
                    icon={<MdKeyboardArrowRight />}
                    iconPosition="forced-right"
                    iconColor="white"
                    iconSize={25}
                >
                    <Typography intrinsic="h4">Commencer</Typography>
                </Button>
            </CustomBottomBar>
        </Container>
    );
};
